import React, {useMemo} from 'react';
import Button, {ButtonProps} from '@mui/material/Button';
import './SelectionModeToggleButton.scss';
import {Typography} from '@mui/material';

export interface SelectionModeToggleButtonProps
  extends Omit<ButtonProps, 'variant' | 'size'> {
  dataTestId?: string;
  text: string;
  isActive: boolean;
}

const SelectionModeToggleButton: React.FC<SelectionModeToggleButtonProps> = ({
  className = '',
  dataTestId = 'prizmdoc-toggle-btn',
  text,
  isActive,
  onClick,
  ...props
}) => {
  const buttonClass = useMemo(() => {
    if (props.disabled) {
      return 'arr-toggle-button-disabled';
    } else if (isActive) {
      return 'arr-toggle-button-active';
    } else {
      return 'arr-toggle-button-inactive';
    }
  }, [isActive, props.disabled]);
  return (
    <Button
      {...props}
      disableRipple
      className={`arr-toggle-button ${buttonClass} ${className}`}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <Typography
        className="typo-text buttonXS_size"
        data-testid={`selection-mode-toggle-button-text-${dataTestId}`}
      >
        {text}
      </Typography>
    </Button>
  );
};

export default SelectionModeToggleButton;
